export default "__VITE_ASSET__e91252a9__"